export const authInputClass =
  "min-h-[44px] w-full rounded-xl border border-white/10 bg-slate-900/50 px-4 py-3 text-sm text-white placeholder:text-slate-500 shadow-[inset_0_1px_0_rgba(255,255,255,0.04)] transition-all duration-300 backdrop-blur-sm focus:border-amber-400/40 focus:bg-slate-900/70 focus:outline-none focus:ring-2 focus:ring-amber-400/15";

export const authButtonClass =
  "min-h-[44px] w-full rounded-xl bg-gradient-to-r from-amber-400/95 via-yellow-500/95 to-amber-500/95 px-4 py-3 text-sm font-semibold uppercase tracking-[0.12em] text-slate-950 shadow-lg shadow-amber-500/15 transition-all duration-300 hover:from-amber-300 hover:via-yellow-400 hover:to-amber-400 hover:shadow-amber-400/25 disabled:cursor-not-allowed disabled:opacity-50";

export const authLinkClass =
  "inline-flex min-h-[44px] items-center font-medium text-amber-300/90 underline-offset-4 transition-colors duration-300 hover:text-amber-200 hover:underline";

export const authFooterClass =
  "mt-8 text-center text-sm font-light text-slate-400";
